// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__XB0WU","hand":"Home_hand__B79fa","wave":"Home_wave__igk3S"};